import { render } from "./CookiesNav.vue?vue&type=template&id=6b4e9634&scoped=true&ts=true"
import script from "./CookiesNav.vue?vue&type=script&lang=ts"
export * from "./CookiesNav.vue?vue&type=script&lang=ts"

import "./CookiesNav.vue?vue&type=style&index=0&id=6b4e9634&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4e9634"]])

export default __exports__